export const DATA_SUMMARY_MODAL_I18N_PREFIX = "features.topics.components.data_summary_modal";

export const DATA_SUMMARY_MODAL_I18N_KEYS = {
  modal_title:                     "modal_title",
  select_another_file_button_text: "select_another_file_button_text",
  confirm_file_button_text:        "confirm_file_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/DataSummaryModali18nConstants.js